import styled from 'styled-components/native';

export const CampaignItem = styled.View`
  flex: 2;
  margin: 10px;
`;
